import { call, put, select, takeLatest } from "redux-saga/effects";
import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

// Initial state
const initialState = {
  loading: false,
  loaded: null,
  data: null,
  branchList: [],
  selectedBranchId: null,
  selectedBranchName: null,
  tel: null,
  area: null,
};

// Slice
const getBranchesSlice = createSlice({
  name: "getBranches",
  initialState,
  reducers: {
    findBranches() {},
    initBranches(state) {
      return {
        ...state,
        loading: false,
        loaded: null,
        data: null,
        branchList: [],
        selectedBranchId: null,
        selectedBranchName: null,
        tel: null,
        area: null,
      };
    },
    setBranches(state, action) {
      const { branchList } = action.payload;
      return { ...state, branchList };
    },
    setBranchId(state, action) {
      const { selectedBranchId, tel, area, selectedBranchName } =
        action.payload;
      return { ...state, selectedBranchId, selectedBranchName, tel, area };
    },
    fetchDataSuccess(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: false,
        loaded: true,
      };
    },
    fetchDataFailure(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: action.payload,
        loaded: true,
      };
    },
  },
});

export const {
  findBranches,
  initBranches,
  setBranches,
  setBranchId,
  fetchDataSuccess,
  fetchDataFailure,
} = getBranchesSlice.actions;

export default getBranchesSlice.reducer;

//saga
function* fetchDataSaga(action) {
  const peerIp = yield select((state) => state.peerIp.ip);
  try {
    const { headers = {}, apiUrl, data = {} } = action.payload;
    const apiService = axios.create({
      headers: {
        ...headers,
        user_ip: peerIp
      }
    });
    const response = yield call(apiService.post, apiUrl, data);

    yield put(fetchDataSuccess(response.data));
    if (response?.data) {
      const list = response.data;

      yield put(setBranches({ branchList: list }));
    }
  } catch (error) {
    yield put(fetchDataFailure(error));
  }
}

// API 호출을 감시하는 Saga 함수
export function* getBranchesSaga() {
  yield takeLatest(findBranches.type, fetchDataSaga);
}
